let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4tvhv")).then(() => parcelRequire('hx9ka'));